import { ChangeDetectionStrategy, Component } from '@angular/core';

import { AbstractFieldInterventionEntitiesFilterOptionsComponent } from '@connect-services/client/components/abstract-field-intervention-entities-filter-options/abstract-field-intervention-entities-filter-options.component';
import { CheckboxComponent } from '@connect-services/src/lib/components/checkbox/checkbox.component';
import { FieldInterventionForm } from '@connect-services/src/sdk/api';
import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CheckboxComponent, RessourcesModule],
    selector: 'app-form-filter-options',
    styleUrl: './form-filter-options.component.scss',
    templateUrl: './form-filter-options.component.html',
})
export class FormFilterOptionsComponent extends AbstractFieldInterventionEntitiesFilterOptionsComponent {
    protected get sortedForms(): FieldInterventionForm[] {
        return this.sortByCheck<FieldInterventionForm>(
            this.filterEntitiesTableService.formsWithPagination()?.items ?? [],
            this.filterEntitiesTableService.filterByParams()?.forms,
            'id',
        );
    }
}
